// extracted by mini-css-extract-plugin
export default {"svgReset":"BeamsSVGLayer_svgReset__WWrQp"};